export default "__VITE_ASSET__47f53bba__"